import { render, staticRenderFns } from "./MemberTraining.vue?vue&type=template&id=3532c466"
import script from "./MemberTraining.vue?vue&type=script&lang=js"
export * from "./MemberTraining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports